export const ADD_TO_CART_BUTTON_RADIUS_MIN = 0;
export const ADD_TO_CART_BUTTON_RADIUS_MAX = 50;
export const ADD_TO_CART_BUTTON_BORDER_WIDTH_MIN = 0;
export const ADD_TO_CART_BUTTON_BORDER_WIDTH_MAX = 20;

export enum AddToCartButtonStyle {
  Filled,
  Outlined,
  FilledPill,
  OutlinedPill,
}

export enum AddToCartButtonContent {
  IconAndText,
  TextOnly,
  IconOnly,
}

export enum AddToCartButtonIconType {
  Cart,
  EcomCart,
  Stores,
  ShoppingBag,
  Add,
}

export enum AddToCartButtonWidth {
  Stretched,
  FitToText,
}

export const ADD_TO_CART_BUTTON_STYLE_PRESETS: Record<
  AddToCartButtonStyle,
  {
    borderRadius: number;
    borderWidth: number;
    fillOpacity: number;
    borderOpacity: number;
    textColor: 'reset' | 'border';
  }
> = {
  [AddToCartButtonStyle.Filled]: {
    borderRadius: 0,
    borderWidth: 0,
    fillOpacity: 1,
    borderOpacity: 0,
    textColor: 'reset',
  },
  [AddToCartButtonStyle.Outlined]: {
    borderRadius: 0,
    borderWidth: 1,
    fillOpacity: 0,
    borderOpacity: 1,
    textColor: 'border',
  },
  [AddToCartButtonStyle.FilledPill]: {
    borderRadius: ADD_TO_CART_BUTTON_RADIUS_MAX,
    borderWidth: 0,
    fillOpacity: 1,
    borderOpacity: 0,
    textColor: 'reset',
  },
  [AddToCartButtonStyle.OutlinedPill]: {
    borderRadius: ADD_TO_CART_BUTTON_RADIUS_MAX,
    borderWidth: 1,
    fillOpacity: 0,
    borderOpacity: 1,
    textColor: 'border',
  },
};
